import React from "react";
import { useQuery } from "react-query";
import { useLanguage } from "../context/LanguageContext";
import { getAllBlogTags } from "../services/blogService";

const Tags = () => {
  const { language } = useLanguage();

  const { data } = useQuery({
    queryKey: ["blogTags"],
    queryFn: getAllBlogTags,
    staleTime: 5 * 60 * 1000,
  });

  const tags = data?.content || [];

  if (tags.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="mt-4 pt-2">
        <div className="sd-title">
          <h6 className="fs-16 mb-3">{language === 'pt' ? "Últimas Tags" : "Last Tags"}</h6>
        </div>
        <div className="tagcloud mt-3 d-flex flex-wrap align-items-start gap-1 ">
          {tags.map((tag) => (
            <span className="badge tag-cloud fs-12 mt-2" key={tag.id}>
              {tag.name}
            </span>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Tags;
